@if (images && images.length) {
  <accordion [openByDefault]="openByDefault" [ariaLabel]="title">
    <div header>
      <h2>{{title}}</h2>
    </div>
    <div body>
      <gallery [customAltText]="customAltText" [images]="images" [showTitle]="true" [useThumbnail]="useThumbnail"
      (favoriteToggle)="favoriteToggle.emit($event)" [displayedImageOverrideId]="displayedImageOverrideId"></gallery>
    </div>
  </accordion>
}